<template>
  <div class="forgot-container">
    <a-card title="忘记密码" class="forgot-card">
      <a-form
          name="forgot"
          :model="formState"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            name="username"
            :rules="[{ required: true, message: '请输入用户名!' }]"
        >
          <a-input v-model:value="formState.username" placeholder="用户名"  />
        </a-form-item>

        <a-form-item
            name="phone"
            :rules="[{ required: true, message: '请输入注册时保留的手机号!' }]"
        >
          <a-input v-model:value="formState.phone" placeholder="手机号"  />
        </a-form-item>

        <a-form-item
            name="password"
            :rules="[{ required: true, message: '请输入新密码!' }]"
        >
          <a-input-password v-model:value="formState.password" placeholder="新密码" />
        </a-form-item>
        <a-form-item
            name="confirm"
            :rules="[
              { required: true, message:'请再次输入密码！'},
              { validator: validateConfirm }
            ]"
        >
          <a-input-password v-model:value="formState.confirm" placeholder="确认密码" />
        </a-form-item>

        <a-form-item
            name="cacheCode"
            :rules="[{ required: true, message: '请输入验证码!' }]"
        >
          <a-input v-model:value="formState.cacheCode" placeholder="验证码"/>
          <a-button :disabled="countdown > 0" @click="sendCode">
            {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
          </a-button>
        </a-form-item>

        <a-form-item>
          <router-link to="/login" id="link-container">返回登录...</router-link>
          <a-button type="primary" html-type="submit" block>
            确认修改
          </a-button>


        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import request from '@/utils/request'
import { ref,reactive } from 'vue'
import {message} from "ant-design-vue";
import router from "@/router/index.js";

const formState=reactive({
  username:"",
  phone:"",
  password:"",
  confirm:"",
  cacheCode:""
});
const countdown = ref(0)
const validateConfirm = (_, value) => {
  if (!value) {
    return Promise.reject()
  }
  if (value !== formState.password) {
    return Promise.reject("两次输入的密码不一致")
  }
  return Promise.resolve()
}

const sendCode = async () => {
  // console.log("send")
  const res=await request.post('/auth/sendCode', null, {
    params: { phone: formState.phone }
  })
  
  // console.log("sent")
  countdown.value = 60
  const timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) clearInterval(timer)
  }, 1000)
}

const onFinish = async (values) => {
  try{
    await request.post("/auth/verifyCode",null,{
      params:{
        username:formState.username,
        code:formState.cacheCode,
        phone:formState.phone,
        newPwd:formState.password
      }
    })
    message.success("修改成功！")
    await router.replace("/login");
  }catch (e)
  {
    message.error(e.message || "修改失败")
  }
}

const onFinishFailed = () => {
  message.error("请填写完整信息！")
}

</script>

<style scoped>
.forgot-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1890ff, #87cefa);
}

.forgot-card {
  width: 350px;
  border-radius: 10px;
}
#link-container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>